import Constants from '../constants/PassengerConstants';
import PassengersConstants from '../constants/PassengersConstants';
import PassengerRemoting from '../../remoting/PassengerRemoting';
import StatusCodes from '../../model/StatusCodes';
import GeneralConstants from '../constants/GeneralConstants';
import PassengersRemoting from '../../remoting/PassengersRemoting';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getSessionToken called on client getting session token and saving it to cookie
 */
export function getPassengerDetails (id, reservationId) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.PASSENGER_REQUEST));
    PassengerRemoting.getPassengerDetails(id || 0, reservationId)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          return dispatch(dispatchToReducer(Constants.PASSENGER_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          dispatch(
            dispatchToReducer(GeneralConstants.GENERAL_DATA_FETCHING_SUCCESS, response.data.general)
          );
          return dispatch(dispatchToReducer(Constants.PASSENGER_SUCCESS, response.data.passenger));
        }
      })
      .catch(error => dispatch(dispatchToReducer(Constants.PASSENGER_FAILURE, error)));
  };
}

/**
 * savePassenger called on client after passenger details changes
 */
export function savePassenger (passenger, general, closePassengerEditor) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.SAVE_PASSENGER_REQUEST));
    PassengerRemoting.savePassengerDetails(passenger, general)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          console.error('Error occured: ', response.message);
          return dispatch(dispatchToReducer(Constants.SAVE_PASSENGER_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          if (response.data) {
            let reservationId =
              response.data.general && response.data.general.reservationId ?
                response.data.general.reservationId :
                '';
            dispatch(dispatchToReducer(Constants.SAVE_PASSENGER_SUCCESS, response.data.passenger));

            if (closePassengerEditor) closePassengerEditor();

            dispatch(dispatchToReducer(PassengersConstants.PASSENGERS_REQUEST));

            /** if successfully saved passenger => refresh passengerList */
            PassengersRemoting.getPassengers(reservationId)
              .then(response => {
                if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
                  console.error('Error occured: ', response.message);
                  return dispatch(
                    dispatchToReducer(PassengersConstants.PASSENGERS_FAILURE, response)
                  );
                }
                if (response && response.status === StatusCodes.OK) {
                  if (response.data.passengers) {
                    return dispatch(
                      dispatchToReducer(
                        PassengersConstants.PASSENGERS_SUCCESS,
                        response.data.passengers
                      )
                    );
                  }
                }
              })
              .catch(error => {
                console.error('Error occured: ', error);
                return dispatch(dispatchToReducer(PassengersConstants.PASSENGERS_FAILURE, error));
              });
          }
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.SAVE_PASSENGER_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/PassengerActions.js